module.exports = __webpack_public_path__ + "static/media/tranfericon.f43af031.svg";